import { EventData, handleVysionEvent } from '../../vysionService';
import { profileUploadGalleryClickVysionEvents } from './click';
import { VYSION_ACTIONS } from '../..';

export const events = {
  [VYSION_ACTIONS.CLICK]: { ...profileUploadGalleryClickVysionEvents },
};

export const handleUploadGAlleryVysionEvent = (data: EventData): void => {
  handleVysionEvent<typeof events>(data, events);
};
